import { useState } from 'react';
import { useScript } from 'scbk-services';
import { getAnalyticsScriptUrl } from '../config/adobeConfig';
import { adobeAnalytiesUseYn } from '../constants/adobeConstants';

export const useAnalyticsLoader = () => {
  const enabled = adobeAnalytiesUseYn == 'Y' ? true : false;

  const scriptUrl = getAnalyticsScriptUrl();

  const [ready, setReady] = useState(false);

  if (enabled && scriptUrl) {
    useScript({
      src: scriptUrl,
      strategy: 'afterInteractive',
      onReady: () => {
        setReady(true);
        console.log('adobe on Ready!!');
      },
      onError: () => {
        console.log('adobe on Error!!');
      },
    });
  }

  return {
    enabled,
    ready,
  };
};
